import { useQuery } from '@tanstack/react-query';
import { resources } from '../../core/services/resources';

/**
 * Lazily fetches one visualization's base64 image and returns it as a data URI.
 * List endpoints omit the image bytes, so every place that shows an image loads
 * it on demand; the cache is shared across components by the visualization id.
 */
export function useVisualizationImage(id: number | null | undefined, enabled = true) {
  const query = useQuery({
    queryKey: ['document-visualization', id],
    queryFn: () => resources.documentVisualizations.get(id!),
    enabled: enabled && id != null,
    staleTime: Infinity,
  });

  const src = query.data?.imageData
    ? `data:${query.data.mimeType};base64,${query.data.imageData}`
    : undefined;

  return { src, isLoading: query.isLoading };
}
